/*!
 * LorenZone — Ma Collection V2 : encart « Ma Collection » des fiches cartes.
 * « Je l'ai déjà » (ajout à la collection) + progression de la série + lien
 * direct vers les cartes manquantes. Fonctionne aussi sans compte (mode
 * visiteur de lz-api-client.js).
 */
(function () {
  var dataEl = document.getElementById('lzmc-product');
  if (!dataEl) return;
  var d;
  try { d = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function start() {
    var M = window.LZMC, api = window.lzApi;
    if (!M || !api) { setTimeout(start, 150); return; }
    mount(M, api);
  }

  function findAnchor() {
    var sels = ['product-info .product-form', '.product__info-container .product-form', 'form[action*="/cart/add"]', '.product__info-container', '[id^="ProductInfo-"]'];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) return el;
    }
    return null;
  }

  function mount(M, api) {
    var anchor = findAnchor();
    if (!anchor) return;
    var box = document.createElement('aside');
    box.className = 'lzmc-pbox';
    box.setAttribute('aria-label', 'Ma Collection');
    var target = anchor.matches('form') ? (anchor.closest('.product-form') || anchor) : anchor;
    target.parentNode.insertBefore(box, target.nextSibling);

    var owned = false;
    var seriesUrl = '/collections/' + encodeURIComponent(d.s);
    var guest = api.mode && api.mode() === 'guest';

    function render(progressHtml) {
      box.innerHTML =
        '<div class="lzmc-pbox__head"><span class="lzmc-bar__brand">Ma Collection</span>' +
        (guest ? '<span class="lzmc-badge">Sur cet appareil</span>' : '') + '</div>' +
        '<button type="button" class="lzmc-btn lzmc-btn--ghost lzmc-btn--sm lzmc-pbox__own' + (owned ? ' is-owned' : '') + '" aria-pressed="' + owned + '">' +
        (owned ? '✅ Dans ta collection' : '➕ Je l\'ai déjà : l\'ajouter à ma collection') + '</button>' +
        '<p class="lzmc-pbox__serie">' + (progressHtml || ('Série <a href="' + seriesUrl + '">' + M.esc(d.st) + '</a>')) + '</p>';
    }

    function progress() {
      return Promise.all([M.series(d.s), api.collectionLoad({ universe: d.u })]).then(function (r) {
        var s = r[0], own = r[1];
        if (!own || !own.ok) return null;
        var m = M.missing(s, { products: own.data.products, variants: own.data.variants });
        if (!m.owned) return 'Série <a href="' + seriesUrl + '">' + M.esc(d.st) + '</a> : ' + m.total + ' cartes. Coche celles que tu as pour voir ce qu\'il te manque.';
        var html = 'Série <a href="' + seriesUrl + '">' + M.esc(d.st) + '</a> : <b>' + m.owned + '/' + m.total + '</b> (' + m.pct + ' %)';
        if (m.missing.length) {
          html += '. Il te manque ' + M.plural(m.missing.length, 'carte', 'cartes') +
            (m.buyable.length ? ', dont <b>' + m.buyable.length + ' en stock</b> (' + M.money(m.buyableCents) + ')' : '') +
            '. <a href="' + seriesUrl + '?lzmc=manquantes">Voir ce qui me manque →</a>';
        } else html += ' 🏆';
        return html;
      }).catch(function () { return null; });
    }

    api.collectionLoad({ universe: d.u }).then(function (r) {
      owned = !!(r && r.ok && (r.data.products || []).indexOf(String(d.p)) >= 0);
      render();
      progress().then(function (h) { if (h) render(h); });
    });

    box.addEventListener('click', function (e) {
      var b = e.target.closest('.lzmc-pbox__own');
      if (!b) return;
      if (api.mode && api.mode() === 'unavailable') { M.toast('Ma Collection est momentanément indisponible', 'error'); return; }
      // Retrait en deux temps, comme sur les pages de série (évite les erreurs).
      if (owned && b.dataset.confirm !== '1') {
        b.dataset.confirm = '1';
        b.textContent = 'Confirmer : retirer de ma collection ?';
        b.classList.add('is-danger');
        setTimeout(function () { if (b.isConnected && b.dataset.confirm === '1') render(); }, 4000);
        return;
      }
      var next = !owned;
      owned = next;
      render();
      var jobs = [api.toggleProduct({ universe: d.u, productId: d.p, owned: next, seriesHandle: d.s, productTitle: d.t })];
      if (d.pv) jobs.push(api.toggleVariant({ universe: d.u, variantId: d.pv, owned: next, variantKind: 'normal', seriesHandle: d.s, productTitle: d.t }));
      Promise.all(jobs).then(function (res) {
        if (!res.every(function (x) { return x && x.ok; })) {
          owned = !next; render();
          M.toast('Impossible d\'enregistrer, réessaie', 'error');
          return;
        }
        M.dropSeries && M.dropSeries(d.s);
        M.toast(next ? '✅ Ajoutée à ta collection' + (guest ? ' (sur cet appareil)' : '') : 'Retirée de ta collection', 'ok');
        progress().then(function (h) { if (h) render(h); });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
